import { render } from "./EndingBalanceDialog.vue?vue&type=template&id=58f8dbab"
import script from "./EndingBalanceDialog.vue?vue&type=script&lang=js"
export * from "./EndingBalanceDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__